/**
 * Quick add for the split-products solo composition.
 *
 * The button lives in a real /cart/add form, so with no JavaScript the add
 * still works as a native post. This upgrades the click to the theme's AJAX
 * add by dispatching theme:cart:add with the button, exactly the pattern
 * ph-recommendations.js proved out - including the guard that the theme's
 * cart-items element is UPGRADED, not merely present in the parsed HTML:
 * dispatching into that window loses the click entirely on slow connections,
 * so an un-upgraded element falls back to the native post instead.
 *
 * Kept separate from ph-recommendations.js on purpose: that file only binds
 * buttons inside its own recommendation holders during init, and widening a
 * load-bearing file's reach for a one-button feature is how blast radius
 * grows. Same idiom, own scope.
 */
(function () {
  'use strict';

  function bind(button) {
    if (button.hasAttribute('data-split-quick-add-init')) return;
    button.setAttribute('data-split-quick-add-init', '');

    var reset = function () {
      window.setTimeout(function () {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.classList.remove('is-added');
      }, 1200);
    };
    button.addEventListener('theme:product:add', reset);
    button.addEventListener('theme:product:add-error', reset);

    button.addEventListener('click', function (event) {
      if (!customElements.get('cart-items') || !document.querySelector('cart-items')) return;

      event.preventDefault();
      if (window.a11y) window.a11y.lastElement = button;

      document.dispatchEvent(
        new CustomEvent('theme:cart:add', {
          detail: { button: button },
        })
      );

      // Safety net only - the add/add-error listeners do the real reset. An
      // immediate reset here re-enables mid-flight and doubles the line.
      window.setTimeout(reset, 5000);
    });
  }

  function start(scope) {
    Array.prototype.forEach.call(
      (scope || document).querySelectorAll('[data-split-quick-add]'),
      bind
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }

  // Theme editor re-renders replace the section's DOM; bind() is idempotent.
  document.addEventListener('shopify:section:load', function (e) {
    start(e.target || document);
  });
})();
